export default {"src":"/_next/static/media/word.32460618.svg","height":512,"width":513};